const appLocales = {
  'en-US': {
    common: {
      brandName: 'Adfini',
      brandTagline: 'Your Jewelry Creative Studio',
      logoAlt: 'Adfini logo',
      back: 'Back',
      dashboard: 'Dashboard',
      library: 'Library',
      projects: 'Projects',
      logout: 'Logout',
      localeLabel: 'Locale',
    },
    media: {
      logo: '/media/homepage/images/Adfini_horizontal_logo.png',
      dashboardHero: '/media/homepage/images/adfini_banner.png',
      dashboardHeroAlt: 'Adfini jewelry banner',
      authHero: '/media/homepage/images/login_right_image.png',
    },
    auth: {
      welcomeBack: 'Welcome Back',
      signInSubtitle: 'Sign in to continue creating',
      createAccount: 'Create Account',
      registerSubtitle: 'Start creating stunning jewelry visuals',
      openGoogle: 'Opening Google...',
      continueGoogle: 'Continue with Google',
      orEmail: 'or email',
      orRegisterEmail: 'or register with email',
      emailAddress: 'Email Address',
      password: 'Password',
      fullName: 'Full Name',
      forgotPassword: 'Forgot password?',
      signIn: 'Sign In',
      signingIn: 'Signing in...',
      creatingAccount: 'Creating Account...',
      noAccount: "Don't have an account?",
      signUp: 'Sign up',
      hasAccount: 'Already have an account?',
      signInLink: 'Sign in',
      firebaseSigninHelp: 'Firebase is required for sign-in. Add REACT_APP_FIREBASE_* to frontend/.env and restart yarn start.',
      firebaseRegisterHelp: 'Firebase is required for registration. Add REACT_APP_FIREBASE_* to frontend/.env and restart the dev server.',
      transformTitle: 'Transform Your Jewelry Business',
      transformSubtitle: 'Create professional product photos and videos that convert browsers into buyers',
      premiumTitle: 'Premium Jewelry Visuals in Minutes',
      premiumSubtitle: 'Join thousands of jewelry sellers creating stunning product photos and videos with AI',
      resetPassword: 'Reset Password',
      resetSubtitle: 'Enter your email to receive a Firebase reset link',
      backToLogin: 'Back to Login',
      resetSuccess: 'If an account exists with that email, you will receive a password reset link.',
      resetCheckEmail: 'Check your email and follow the instructions to reset your password.',
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      firebaseNotConfigured: 'Firebase is not configured. Add REACT_APP_FIREBASE_* to frontend/.env.',
      invalidResetLink: 'Invalid Reset Link',
      invalidResetHelp: 'Open the reset link from your email, or request a new one. Password reset uses Firebase only.',
      requestNewLink: 'Request New Link',
      setNewPassword: 'Set New Password',
      setNewPasswordSubtitle: 'Create a strong password for your Firebase account',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      resetPasswordAction: 'Reset Password',
      resetting: 'Resetting...',
      passwordMismatch: 'Passwords do not match',
      passwordLength: 'Password must be at least 8 characters',
      invalidLink: 'Invalid reset link',
      passwordResetSuccess: 'Password reset successful! You can now sign in with your new password.',
      registerLegalIntro: 'I agree to the',
      registerTermsLink: 'Terms of Service',
      registerLegalAnd: 'and',
      registerPrivacyLink: 'Privacy Policy',
      registerLegalEnd: '.',
      registerMustAcceptLegal: 'Please accept the Terms of Service and Privacy Policy to continue.',
    },
    library: {
      title: 'Library',
      subtitle: 'History and memory-backed creation access',
      searchPlaceholder: 'Search creations, status, or checkpoints',
      loading: 'Loading library...',
      emptyTitle: 'No creations match this view',
      emptyHelp: 'Adjust filters or create a new one.',
      waitingOn: 'Waiting on',
      final: 'Final',
      idle: 'Idle',
      historyView: 'History view',
    },
    projects: {
      backToDashboard: 'Back to Dashboard',
      title: 'My Projects',
      newProject: 'New Project',
      loading: 'Loading projects...',
      emptyTitle: 'No projects yet',
      emptyHelp: 'Organize your jewelry visuals into projects',
      createFirst: 'Create First Project',
      created: 'Created',
      modalTitle: 'Create New Project',
      projectTitle: 'Project Title',
      projectDescription: 'Description (Optional)',
      projectTitlePlaceholder: 'e.g., Spring Collection 2026',
      projectDescriptionPlaceholder: 'Describe this project...',
      cancel: 'Cancel',
      create: 'Create',
      creating: 'Creating...',
      createFailed: 'Failed to create project',
    },
    settings: {
      backToDashboard: 'Back to Dashboard',
      title: 'Settings',
      profile: 'Profile',
      profileHelp: 'Update your name and contact email. To reset your password, use "Forgot password" on the sign-in page.',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
      profileUpdated: 'Profile updated successfully!',
      profileUpdateFailed: 'Failed to update profile',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'you@example.com',
      legalLinksIntro: 'Policies and support',
    },
    admin: {
      workspace: 'Administration',
      navigation: 'Admin',
      description: 'Manage accounts, credits and production activity.',
      refresh: 'Refresh',
      refreshing: 'Refreshing\u2026',
      retry: 'Try again',
      statsFailed: 'Could not load the overview. Refresh to try again.',
      usersFailed: 'Could not load accounts. Try again.',
      activityFailed: 'Could not load this account\u2019s activity. Try again.',
      logsFailed: 'Could not load server logs. Try again.',
      creditSaveFailed: 'Credits could not be added. Try again.',
      usersHint: 'Account balances and access across Adfini.',
      showingUsers: '{shown} of {total} loaded',
      searchUsers: 'Search name or email',
      allRoles: 'All roles',
      adminRole: 'Admin',
      userRole: 'User',
      account: 'Account',
      you: 'You',
      noMatches: 'No accounts match your search. Change the name, email or role.',
      noUsers: 'No accounts to display.',
      creditAmount: 'Credits to add',
      savingCredits: 'Adding credits\u2026',
      cancel: 'Cancel',
      closeDetails: 'Close account details',
      generationsHint: 'The latest 10 productions across all accounts.',
      logsDescription: 'Inspect application logs for troubleshooting.',
      noLogFiles: 'No files available',
      lines: 'lines',
      logFileEmpty: 'This log file is empty.',
      logPreviewHint: 'Choose a file to inspect its latest entries.',
      logPreviewDetail: 'Load a log to view it here.',
      title: 'Admin Dashboard',
      backToDashboard: 'Back to Dashboard',
      loading: 'Loading admin data...',
      totalUsers: 'Total Users',
      totalGenerations: 'Total Generations',
      totalProjects: 'Total Projects',
      transactions: 'Transactions',
      allUsers: 'All Users',
      email: 'Email',
      name: 'Name',
      credits: 'Credits',
      role: 'Role',
      joined: 'Joined',
      actions: 'Actions',
      addCredits: 'Add Credits',
      promptCredits: 'How many credits to add?',
      creditsAdded: 'Added {credits} credits to {email}',
      creditsFailed: 'Failed to add credits: {error}',
      recentGenerations: 'Recent Generations',
      status: 'Status',
      freeCredits: 'Free',
      paidCredits: 'Paid',
      totalCredits: 'Total',
      viewDetails: 'Details',
      hideDetails: 'Hide',
      userCreations: 'Creations',
      creditLedger: 'Credit ledger',
      ledgerCreditType: 'Pool',
      ledgerTxnType: 'Kind',
      ledgerAmount: 'Amount',
      ledgerSource: 'Source',
      ledgerDate: 'Date',
      creationMode: 'Mode',
      creationUpdated: 'Updated',
      noCreations: 'No creations yet',
      noLedgerEntries: 'No credit transactions yet',
      detailLoading: 'Loading user activity…',
      userId: 'User ID',
      diagnosticsHeading: 'Diagnostics',
      serverLogsHeading: 'Server log files',
      logSourceLabel: 'Source',
      logFileLabel: 'File',
      logTailLines: 'Tail lines',
      loadLogButton: 'Load log',
      logsLoading: 'Loading logs…',
      logsEmpty: 'No log sources configured or directories are empty.',
      logsHint:
      'Backend logs use APP_LOG_DIR. Additional proxy logs can use ADMIN_EXTRA_LOG_DIRS.',
      truncatedNotice: '(truncated)',
    },
    profileMenu: {
      triggerLabel: 'Profile',
      signedInAs: 'Signed in as',
      balanceHeading: 'Credit balance',
      totalLine: '{total} total credits',
      freePaidLine: '{free} free · {paid} paid',
      creditsAndPlans: 'Credits & plans',
      accountSettings: 'Account settings',
      adminDashboard: 'Admin dashboard',
      legalHeading: 'Legal',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      refundPolicy: 'Refund Policy',
      helpSupport: 'Help & support',
      signOut: 'Sign out',
    },
    dashboard: {
      creditsSuffix: 'credits',
      createNew: 'Create new',
      openLibrary: 'Open library',
      recentCreations: 'Recent creations',
      latestWork: 'Pick up your latest jewelry work.',
      viewAll: 'View all',
      loadingRecent: 'Loading recent creations...',
      noCreations: 'No creations yet',
      noCreationsHelp: 'Start your first jewelry project and it will show up here.',
      startCreating: 'Start creating',
      untitledCreation: 'Untitled creation',
      totalCredits: 'Total credits',
      freePaid: 'Free / Paid',
      dashboardBadge: 'Dashboard',
      heroTitle: 'Create standout jewelry visuals, fast.',
      heroSubtitle: 'Upload jewelry photos, choose an Auto preset, and get polished videos for your catalogue and campaigns.',
      modeLabels: {
        'catalogue-jewellery': 'Catalogue Jewelry',
        'jewellery-film': 'Jewelry Video',
        'app-commercial-film': 'App Commercial Videos',
      },
      statusLabels: {
        completed: 'Ready',
        running: 'In progress',
        processing: 'In progress',
        queued: 'Queued',
        failed: 'Needs attention',
        paused: 'Paused',
        review: 'Needs your review',
      },
    },
    billing: {
      backToDashboard: 'Back to Dashboard',
      heroTitle: 'Create your first AI video for free',
      heroSubtext: 'New users get 30 free credits. Paid videos start at just $3.',
      pricingExplainerLines: [
        '$1 = 10 credits.',
        '15s videos use 30 credits.',
        '30s videos use 60 credits.',
        '45s videos use 90 credits.',
      ],
      checkingPayment: 'Checking payment status...',
      popular: 'Popular',
      packBulletFirst: 'Credits work across all Adfini modes and features',
      allStylePresets: 'All style presets',
      commercialUse: 'Commercial use',
      processing: 'Processing...',
      purchase: 'Purchase',
      howCreditsWork: 'How Credits Work',
      howCreditsBullets: [
        'New users automatically receive 30 free credits',
        'Free credits are used first',
        'Paid credits are used after free credits',
        '15s video = 30 credits',
        '30s video = 60 credits',
        '45s video = 90 credits',
        'Final usage may vary based on selected features/styles',
        'Unused credits remain in account',
      ],
      paymentTimeout: 'Payment status check timed out. Please check your credits.',
      paymentSuccess: 'Payment successful! {credits} credits added.',
      paymentExpired: 'Payment session expired. Please try again.',
      checkoutFailed: 'Checkout failed: {error}',
      noCheckoutUrl: 'No checkout URL received',
      paymentDisclaimerBeforeRefund: 'Paid credit purchases are subject to our ',
      refundPolicyLink: 'Refund Policy',
      paymentDisclaimerBetween: ' and ',
      termsOfServiceLink: 'Terms of Service',
      paymentDisclaimerAfter: '.',
      packDetails: {
        starter: {
          tagline: 'Great for trying your first short video',
          approxOutput: 'Approx output: ~1 short video',
        },
        professional: {
          tagline: 'Best for regular creators',
          approxOutput: 'Approx output: ~2–5 videos depending on length/style',
        },
        enterprise: {
          tagline: 'Best for agencies, brands, and higher-volume creators',
          approxOutput: 'Approx output: ~8–20 videos depending on length/style',
        },
      },
    },
    create: {
      auto: 'Auto',
      back: 'Back',
      continue: 'Continue',
      add: 'Add',
      defaultBrief: 'Auto jewelry video with premium studio lighting, close-up detail, and a polished campaign feel.',
      loadingSetup: 'Loading creation setup...',
      noModesTitle: 'No preset-enabled jewelry modes available',
      noModesHelp: 'Please try again in a moment.',
      createLoadingTitle: 'Adfini is crafting your video',
      createLoadingSubtitle: 'Selecting style, planning scenes, and bringing your jewelry to life.',
      durationPricingIntro:
        'Longer videos use more credits: 15s = 30, 30s = 60, 45s = 90 (+30 credits per extra 15 seconds).',
      durationCredits15: '30 credits',
      durationCredits30: '60 credits',
      durationCredits45: '90 credits',
      finalCreditSummary:
        'This run uses {credits} credits for your selected length. Free: {free}, Paid: {paid}, Total: {total}.',
      presetBadge: 'Auto',
      presetTitle: 'Choose your visual preset',
      presetSubtitle:
        'For now, every run uses Auto—Adfini handles the production path and keeps review light. Pick the look that fits your project.',
      presetBodyHint:
        'This steers the engine without full manual setup. Scene planning and checkpoints still run automatically.',
      presetTipLabel: 'Tip',
      presetTipBody: 'Pick the closest overall look. You can add start references on the next upload step.',
      presetLoading: 'Loading presets...',
      presetEmptyFallback: 'No presets are available for this mode right now.',
      presetSelectedLabel: 'Selected:',
      presetSelectedNone: 'None',
      detailsTitle: 'Tell us a bit about your creation',
      detailsSubtitle: 'Add a name and an optional brief so Auto can stay on track without extra steps.',
      creationNameLabel: 'Creation name',
      creationNamePlaceholder: 'Example: Spring campaign hero',
      briefLabel: 'Client brief (optional)',
      briefPlaceholder: 'Example: Elegant close-ups, warm studio lighting, premium feel.',
      videoDurationLabel: 'Video duration',
      uploadTitle: 'Upload your images',
      uploadSubtitle: 'Start with at least one clear image—product shots, phone photos, or catalog images all work.',
      dropzoneTitle: 'Drag and drop, or click to upload',
      dropzoneSubtitle: 'JPG, PNG, or WEBP up to your browser limit. Add multiple angles when you have them.',
      uploadSubtitle: 'Please provide at least two images - product shots, phone photos, or catalog images',
      dropzoneSubtitle: 'JPG, PNG, or WEBP up to 10 MB in size and at least 300 px. Add multiple angles when you have them.',
      needAtLeastTwoImages: 'Need at least two images to continue.',
      imageTypeValidationError: 'Please upload image files only (JPG, PNG, or WEBP).',
      imageSizeValidationError: 'Each image must be 10 MB or smaller.',
      imageDimensionValidationError: 'Each image must be at least 300 px on width or height.',
      inputGuideTitle: 'Good jewellery input examples',
      inputGuideSubtitle: 'Use clear, well-lit photos where the jewellery is the main focus.',
      finalTitle: 'All set. Ready to generate',
      finalSubtitle: 'We will start your video in Auto mode and open the review workspace when the run is ready.',
      summaryModeLabel: 'Mode',
      summaryDurationLabel: 'Duration',
      summaryScenesLabel: 'Scenes',
      summaryImagesLabel: 'Images',
      creationNameInline: 'Creation name:',
      notEnoughCredits: 'Not enough credits',
      buyMoreCredits: 'Buy More Credits',
      buyCreditsTitle: 'Top up credits to continue',
      buyCreditsSubtitle: 'Choose a package below. Checkout is secure via Stripe.',
      closeBuyCredits: 'Close buy credits dialog',
      loadingCreditPackages: 'Loading credit packages...',
      creditPackagesUnavailable: 'Credit packages are unavailable right now. Please try again shortly.',
      generating: 'Generating...',
      generateVideo: 'Generate video',
      untitledCreation: 'Untitled',
      loadingStages: {
        upload_assets: 'Uploading jewelry images.',
        building_run: 'Starting Auto mode with the selected jewelry preset.',
        syncing_intake: 'Applying duration, scene defaults, and brief context.',
        loading_review: 'Opening your review workspace.',
      },
    },
  },
  'en-IN': {
    common: {
      brandName: 'Adfini',
      brandTagline: 'Your Jewellery Creative Studio',
      logoAlt: 'Adfini logo',
      back: 'Back',
      dashboard: 'Dashboard',
      library: 'Library',
      projects: 'Projects',
      logout: 'Logout',
      localeLabel: 'Locale',
    },
    media: {
      logo: '/media/homepage/images/Adfini_horizontal_logo.png',
      dashboardHero: '/media/homepage/images/adfini_banner.png',
      dashboardHeroAlt: 'Adfini jewellery banner',
      authHero: '/media/homepage/images/login_right_image.png',
    },
    auth: {
      welcomeBack: 'Welcome Back',
      signInSubtitle: 'Sign in to continue creating',
      createAccount: 'Create Account',
      registerSubtitle: 'Start creating stunning jewellery visuals',
      openGoogle: 'Opening Google...',
      continueGoogle: 'Continue with Google',
      orEmail: 'or email',
      orRegisterEmail: 'or register with email',
      emailAddress: 'Email Address',
      password: 'Password',
      fullName: 'Full Name',
      forgotPassword: 'Forgot password?',
      signIn: 'Sign In',
      signingIn: 'Signing in...',
      creatingAccount: 'Creating Account...',
      noAccount: "Don't have an account?",
      signUp: 'Sign up',
      hasAccount: 'Already have an account?',
      signInLink: 'Sign in',
      firebaseSigninHelp: 'Firebase is required for sign-in. Add REACT_APP_FIREBASE_* to frontend/.env and restart yarn start.',
      firebaseRegisterHelp: 'Firebase is required for registration. Add REACT_APP_FIREBASE_* to frontend/.env and restart the dev server.',
      transformTitle: 'Transform Your Jewellery Business',
      transformSubtitle: 'Create professional product photos and videos that convert browsers into buyers',
      premiumTitle: 'Premium Jewellery Visuals in Minutes',
      premiumSubtitle: 'Join thousands of jewellery sellers creating stunning product photos and videos with AI',
      resetPassword: 'Reset Password',
      resetSubtitle: 'Enter your email to receive a Firebase reset link',
      backToLogin: 'Back to Login',
      resetSuccess: 'If an account exists with that email, you will receive a password reset link.',
      resetCheckEmail: 'Check your email and follow the instructions to reset your password.',
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      firebaseNotConfigured: 'Firebase is not configured. Add REACT_APP_FIREBASE_* to frontend/.env.',
      invalidResetLink: 'Invalid Reset Link',
      invalidResetHelp: 'Open the reset link from your email, or request a new one. Password reset uses Firebase only.',
      requestNewLink: 'Request New Link',
      setNewPassword: 'Set New Password',
      setNewPasswordSubtitle: 'Create a strong password for your Firebase account',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      resetPasswordAction: 'Reset Password',
      resetting: 'Resetting...',
      passwordMismatch: 'Passwords do not match',
      passwordLength: 'Password must be at least 8 characters',
      invalidLink: 'Invalid reset link',
      passwordResetSuccess: 'Password reset successful! You can now sign in with your new password.',
      registerLegalIntro: 'I agree to the',
      registerTermsLink: 'Terms of Service',
      registerLegalAnd: 'and',
      registerPrivacyLink: 'Privacy Policy',
      registerLegalEnd: '.',
      registerMustAcceptLegal: 'Please accept the Terms of Service and Privacy Policy to continue.',
    },
    library: {
      title: 'Library',
      subtitle: 'History and memory-backed creation access',
      searchPlaceholder: 'Search creations, status, or checkpoints',
      loading: 'Loading library...',
      emptyTitle: 'No creations match this view',
      emptyHelp: 'Adjust filters or create a new one.',
      waitingOn: 'Waiting on',
      final: 'Final',
      idle: 'Idle',
      historyView: 'History view',
    },
    projects: {
      backToDashboard: 'Back to Dashboard',
      title: 'My Projects',
      newProject: 'New Project',
      loading: 'Loading projects...',
      emptyTitle: 'No projects yet',
      emptyHelp: 'Organize your jewellery visuals into projects',
      createFirst: 'Create First Project',
      created: 'Created',
      modalTitle: 'Create New Project',
      projectTitle: 'Project Title',
      projectDescription: 'Description (Optional)',
      projectTitlePlaceholder: 'e.g., Spring Collection 2026',
      projectDescriptionPlaceholder: 'Describe this project...',
      cancel: 'Cancel',
      create: 'Create',
      creating: 'Creating...',
      createFailed: 'Failed to create project',
    },
    settings: {
      backToDashboard: 'Back to Dashboard',
      title: 'Settings',
      profile: 'Profile',
      profileHelp: 'Update your name and contact email. To reset your password, use "Forgot password" on the sign-in page.',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
      profileUpdated: 'Profile updated successfully!',
      profileUpdateFailed: 'Failed to update profile',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'you@example.com',
      legalLinksIntro: 'Policies and support',
    },
    admin: {
      workspace: 'Administration',
      navigation: 'Admin',
      description: 'Manage accounts, credits and production activity.',
      refresh: 'Refresh',
      refreshing: 'Refreshing\u2026',
      retry: 'Try again',
      statsFailed: 'Could not load the overview. Refresh to try again.',
      usersFailed: 'Could not load accounts. Try again.',
      activityFailed: 'Could not load this account\u2019s activity. Try again.',
      logsFailed: 'Could not load server logs. Try again.',
      creditSaveFailed: 'Credits could not be added. Try again.',
      usersHint: 'Account balances and access across Adfini.',
      showingUsers: '{shown} of {total} loaded',
      searchUsers: 'Search name or email',
      allRoles: 'All roles',
      adminRole: 'Admin',
      userRole: 'User',
      account: 'Account',
      you: 'You',
      noMatches: 'No accounts match your search. Change the name, email or role.',
      noUsers: 'No accounts to display.',
      creditAmount: 'Credits to add',
      savingCredits: 'Adding credits\u2026',
      cancel: 'Cancel',
      closeDetails: 'Close account details',
      generationsHint: 'The latest 10 productions across all accounts.',
      logsDescription: 'Inspect application logs for troubleshooting.',
      noLogFiles: 'No files available',
      lines: 'lines',
      logFileEmpty: 'This log file is empty.',
      logPreviewHint: 'Choose a file to inspect its latest entries.',
      logPreviewDetail: 'Load a log to view it here.',
      title: 'Admin Dashboard',
      backToDashboard: 'Back to Dashboard',
      loading: 'Loading admin data...',
      totalUsers: 'Total Users',
      totalGenerations: 'Total Generations',
      totalProjects: 'Total Projects',
      transactions: 'Transactions',
      allUsers: 'All Users',
      email: 'Email',
      name: 'Name',
      credits: 'Credits',
      role: 'Role',
      joined: 'Joined',
      actions: 'Actions',
      addCredits: 'Add Credits',
      promptCredits: 'How many credits to add?',
      creditsAdded: 'Added {credits} credits to {email}',
      creditsFailed: 'Failed to add credits: {error}',
      recentGenerations: 'Recent Generations',
      status: 'Status',
      freeCredits: 'Free',
      paidCredits: 'Paid',
      totalCredits: 'Total',
      viewDetails: 'Details',
      hideDetails: 'Hide',
      userCreations: 'Creations',
      creditLedger: 'Credit ledger',
      ledgerCreditType: 'Pool',
      ledgerTxnType: 'Kind',
      ledgerAmount: 'Amount',
      ledgerSource: 'Source',
      ledgerDate: 'Date',
      creationMode: 'Mode',
      creationUpdated: 'Updated',
      noCreations: 'No creations yet',
      noLedgerEntries: 'No credit transactions yet',
      detailLoading: 'Loading user activity…',
      userId: 'User ID',
      diagnosticsHeading: 'Diagnostics',
      serverLogsHeading: 'Server log files',
      logSourceLabel: 'Source',
      logFileLabel: 'File',
      logTailLines: 'Tail lines',
      loadLogButton: 'Load log',
      logsLoading: 'Loading logs…',
      logsEmpty: 'No log sources configured or directories are empty.',
      logsHint:
      'Backend logs use APP_LOG_DIR. Additional proxy logs can use ADMIN_EXTRA_LOG_DIRS.',
      truncatedNotice: '(truncated)',
    },
    profileMenu: {
      triggerLabel: 'Profile',
      signedInAs: 'Signed in as',
      balanceHeading: 'Credit balance',
      totalLine: '{total} total credits',
      freePaidLine: '{free} free · {paid} paid',
      creditsAndPlans: 'Credits & plans',
      accountSettings: 'Account settings',
      adminDashboard: 'Admin dashboard',
      legalHeading: 'Legal',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      refundPolicy: 'Refund Policy',
      helpSupport: 'Help & support',
      signOut: 'Sign out',
    },
    dashboard: {
      creditsSuffix: 'credits',
      createNew: 'Create new',
      openLibrary: 'Open library',
      recentCreations: 'Recent creations',
      latestWork: 'Pick up your latest jewellery work.',
      viewAll: 'View all',
      loadingRecent: 'Loading recent creations...',
      noCreations: 'No creations yet',
      noCreationsHelp: 'Start your first jewellery project and it will show up here.',
      startCreating: 'Start creating',
      untitledCreation: 'Untitled creation',
      totalCredits: 'Total credits',
      freePaid: 'Free / Paid',
      dashboardBadge: 'Dashboard',
      heroTitle: 'Create standout jewellery visuals, fast.',
      heroSubtitle: 'Upload jewellery photos, choose an Auto preset, and get polished videos for your catalogue and campaigns.',
      modeLabels: {
        'catalogue-jewellery': 'Catalogue Jewellery',
        'jewellery-film': 'Jewellery Video',
        'app-commercial-film': 'App Commercial Videos',
      },
      statusLabels: {
        completed: 'Ready',
        running: 'In progress',
        processing: 'In progress',
        queued: 'Queued',
        failed: 'Needs attention',
        paused: 'Paused',
        review: 'Needs your review',
      },
    },
    billing: {
      backToDashboard: 'Back to Dashboard',
      heroTitle: 'Create your first AI video for free',
      heroSubtext: 'New users get 30 free credits. Paid videos start at just $3.',
      pricingExplainerLines: [
        '$1 = 10 credits.',
        '15s videos use 30 credits.',
        '30s videos use 60 credits.',
        '45s videos use 90 credits.',
      ],
      checkingPayment: 'Checking payment status...',
      popular: 'Popular',
      packBulletFirst: 'Credits work across all Adfini modes and features',
      allStylePresets: 'All style presets',
      commercialUse: 'Commercial use',
      processing: 'Processing...',
      purchase: 'Purchase',
      howCreditsWork: 'How Credits Work',
      howCreditsBullets: [
        'New users automatically receive 30 free credits',
        'Free credits are used first',
        'Paid credits are used after free credits',
        '15s video = 30 credits',
        '30s video = 60 credits',
        '45s video = 90 credits',
        'Final usage may vary based on selected features/styles',
        'Unused credits remain in account',
      ],
      paymentTimeout: 'Payment status check timed out. Please check your credits.',
      paymentSuccess: 'Payment successful! {credits} credits added.',
      paymentExpired: 'Payment session expired. Please try again.',
      checkoutFailed: 'Checkout failed: {error}',
      noCheckoutUrl: 'No checkout URL received',
      paymentDisclaimerBeforeRefund: 'Paid credit purchases are subject to our ',
      refundPolicyLink: 'Refund Policy',
      paymentDisclaimerBetween: ' and ',
      termsOfServiceLink: 'Terms of Service',
      paymentDisclaimerAfter: '.',
      packDetails: {
        starter: {
          tagline: 'Great for trying your first short video',
          approxOutput: 'Approx output: ~1 short video',
        },
        professional: {
          tagline: 'Best for regular creators',
          approxOutput: 'Approx output: ~2–5 videos depending on length/style',
        },
        enterprise: {
          tagline: 'Best for agencies, brands, and higher-volume creators',
          approxOutput: 'Approx output: ~8–20 videos depending on length/style',
        },
      },
    },
    create: {
      auto: 'Auto',
      back: 'Back',
      continue: 'Continue',
      add: 'Add',
      defaultBrief: 'Auto jewellery video with premium studio lighting, close-up detail, and a polished campaign feel.',
      loadingSetup: 'Loading creation setup...',
      noModesTitle: 'No preset-enabled jewellery modes available',
      noModesHelp: 'Please try again in a moment.',
      createLoadingTitle: 'Adfini is crafting your video',
      createLoadingSubtitle: 'Selecting style, planning scenes, and bringing your jewellery to life.',
      durationPricingIntro:
        'Longer videos use more credits: 15s = 30, 30s = 60, 45s = 90 (+30 credits per extra 15 seconds).',
      durationCredits15: '30 credits',
      durationCredits30: '60 credits',
      durationCredits45: '90 credits',
      finalCreditSummary:
        'This run uses {credits} credits for your selected length. Free: {free}, Paid: {paid}, Total: {total}.',
      presetBadge: 'Auto',
      presetTitle: 'Choose your visual preset',
      presetSubtitle:
        'For now, every run uses Auto—Adfini handles the production path and keeps review light. Pick the look that fits your project.',
      presetBodyHint:
        'This steers the engine without full manual setup. Scene planning and checkpoints still run automatically.',
      presetTipLabel: 'Tip',
      presetTipBody: 'Pick the closest overall look. You can add start references on the next upload step.',
      presetLoading: 'Loading presets...',
      presetEmptyFallback: 'No presets are available for this mode right now.',
      presetSelectedLabel: 'Selected:',
      presetSelectedNone: 'None',
      detailsTitle: 'Tell us a bit about your creation',
      detailsSubtitle: 'Add a name and an optional brief so Auto can stay on track without extra steps.',
      creationNameLabel: 'Creation name',
      creationNamePlaceholder: 'Example: Spring campaign hero',
      briefLabel: 'Client brief (optional)',
      briefPlaceholder: 'Example: Elegant close-ups, warm studio lighting, premium feel.',
      videoDurationLabel: 'Video duration',
      uploadTitle: 'Upload your images',
      uploadSubtitle:
        'Start with at least one clear image—product shots, phone photos, or catalogue images all work.',
      dropzoneTitle: 'Drag and drop, or click to upload',
      dropzoneSubtitle: 'JPG, PNG, or WEBP up to your browser limit. Add multiple angles when you have them.',
      uploadSubtitle: 'Please provide at least two images - product shots, phone photos, or catalog images',
      dropzoneSubtitle: 'JPG, PNG, or WEBP up to 10 MB in size and at least 300 px. Add multiple angles when you have them.',
      needAtLeastTwoImages: 'Need at least two images to continue.',
      imageTypeValidationError: 'Please upload image files only (JPG, PNG, or WEBP).',
      imageSizeValidationError: 'Each image must be 10 MB or smaller.',
      imageDimensionValidationError: 'Each image must be at least 300 px on width or height.',
      inputGuideTitle: 'Good jewellery input examples',
      inputGuideSubtitle: 'Use clear, well-lit photos where the jewellery is the main focus.',
      finalTitle: 'All set. Ready to generate',
      finalSubtitle: 'We will start your video in Auto mode and open the review workspace when the run is ready.',
      summaryModeLabel: 'Mode',
      summaryDurationLabel: 'Duration',
      summaryScenesLabel: 'Scenes',
      summaryImagesLabel: 'Images',
      creationNameInline: 'Creation name:',
      notEnoughCredits: 'Not enough credits',
      buyMoreCredits: 'Buy More Credits',
      buyCreditsTitle: 'Top up credits to continue',
      buyCreditsSubtitle: 'Choose a package below. Checkout is secure via Stripe.',
      closeBuyCredits: 'Close buy credits dialog',
      loadingCreditPackages: 'Loading credit packages...',
      creditPackagesUnavailable: 'Credit packages are unavailable right now. Please try again shortly.',
      generating: 'Generating...',
      generateVideo: 'Generate video',
      untitledCreation: 'Untitled',
      loadingStages: {
        upload_assets: 'Uploading jewellery images.',
        building_run: 'Starting Auto mode with the selected jewellery preset.',
        syncing_intake: 'Applying duration, scene defaults, and brief context.',
        loading_review: 'Opening your review workspace.',
      },
    },
  },
};

export function getAppLocale(locale = 'en-US') {
  return appLocales[locale] || appLocales['en-US'];
}

export function interpolate(template, values) {
  return Object.entries(values || {}).reduce(
    (acc, [key, value]) => acc.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value)),
    template,
  );
}

